const locale = {
    placeholder: 'Vybrat čas',
    rangePlaceholder: ['Počáteční čas', 'Koncový čas'],
};
export default locale;
